export default __webpack_public_path__ + "static/media/slide1.df534cc5.jpg";